import { render, staticRenderFns } from "./Editors.vue?vue&type=template&id=b28d8d22"
import script from "./Editors.vue?vue&type=script&lang=ts"
export * from "./Editors.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports